import axios from 'axios';

const BASE_API_URL = window?.appConfig?.REACT_APP_API_ENDPOINT;

/***
 *  Not in use...using sso login flow
 */

function login(clientId, clientSecret) {
    const requestObj = JSON.stringify({
        clientName: clientId,
        clientSecret: clientSecret
    });
    return axios.post(BASE_API_URL + '/v2/token', requestObj, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

export default {
  login
};
